export default "__VITE_ASSET__CKkDMqLW__"